import React, { ReactElement, useImperativeHandle, useState } from 'react';
import { ROUTE_CHANGE_DEFAULT_MESSAGE } from '../../shared/constants/commonConstants';
import RouteGuardModal from '../../shared/components/modal/RouteGuardModal';

const RouteGuardHandler = React.forwardRef((props: any, ref: any): ReactElement | null => {
  useImperativeHandle(ref, (): any => ({ getConfirmation }));
  const [visible, setVisible] = useState(false);
  const [confirmationCallback, setConfirmationCallback] = useState(null);
  const [message, setMessage] = useState(ROUTE_CHANGE_DEFAULT_MESSAGE);

  const getConfirmation = (messageText: string, callback: any): any => {
    setConfirmationCallback((): any => callback);
    setMessage(messageText);
    setVisible(true);
  };

  return visible ?
    <RouteGuardModal
      visible={visible}
      setVisible={setVisible}
      message={message}
      setMessage={setMessage}
      confirmationCallback={confirmationCallback} /> : null;
});

export default RouteGuardHandler;
